import { render, staticRenderFns } from "./ExcelP17PrapaDebtByAreaReport.vue?vue&type=template&id=9067367c&"
import script from "./ExcelP17PrapaDebtByAreaReport.vue?vue&type=script&lang=js&"
export * from "./ExcelP17PrapaDebtByAreaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports